import { useEffect, useReducer, useRef } from 'react';

import { maskBanWords, onBanWordsLoaded } from './banWordsMasker';

/**
 * 금지어가 마스킹된 표시용 문자열을 반환하는 훅.
 *
 * `maskBanWords` 직접 호출과의 차이는 **지연 로드 보정**이다. 룰은 비동기로 로드되고
 * 그 전엔 fail-open(원문)이라, 채팅 아이템처럼 스냅샷으로 저장되는 값은 원문인 채 굳는다.
 * 이 훅은 로드 성공 시 리렌더해 마스킹된 값으로 교체한다(마스킹은 멱등이라 안전).
 *
 * ⚠️ 구독 전에 로드 여부를 검사하는 가드를 두면 안 된다 — 렌더와 effect 사이에 로드가
 *    끝나면 구독을 건너뛰어 영구히 원문으로 남는다(= 이 훅이 막으려던 바로 그 버그).
 */
export const useMaskedBanWords = (text: string): string => {
  const [, forceUpdate] = useReducer((count: number) => count + 1, 0);

  const masked = maskBanWords(text);

  // 구독은 마운트 시 1회 — 리스너가 최신 값을 보도록 ref 로 넘긴다.
  const textRef = useRef(text);
  const renderedRef = useRef(masked);
  textRef.current = text;
  renderedRef.current = masked;

  useEffect(
    () =>
      onBanWordsLoaded(() => {
        // 값이 달라질 때만 리렌더 (이미 로드된 상태의 즉시 호출은 no-op).
        if (maskBanWords(textRef.current) !== renderedRef.current) {
          forceUpdate();
        }
      }),
    [],
  );

  return masked;
};
